import { Component } from '@angular/core';

@Component({
	selector: 'app-choose-plan',
	templateUrl: './choose-plan.component.html',
	styleUrls: ['./choose-plan.component.scss'],
})
export class ChoosePlanComponent {
	isMonthPlanChoosed = false;
	isAnnualPlanChoosed = false;
	choosingPlan(plan: string): void {
		if (plan == 'month') {
			this.isAnnualPlanChoosed = false;
			this.isMonthPlanChoosed = !this.isMonthPlanChoosed;
		}
		if (plan == 'annual') {
			this.isMonthPlanChoosed = false;
			this.isAnnualPlanChoosed = !this.isAnnualPlanChoosed;
		}
	}
}
